import ConnectionService, { HttpMethod } from './connection.service';

class SlackConnection {
  public async postMessage(data:object): Promise<void>{
    return await ConnectionService.fetch(`integration/slack/postMessage`, HttpMethod.POST, data);
  }
}

export default new SlackConnection();